import { IFactoryProperty } from '../../../models/element-property.model';
import { systemElementCategoryProperties } from '../common-element-category-properties.model';

export const slabProperties: IFactoryProperty[] = [
  ...systemElementCategoryProperties,
];
